// utils/eventBus.ts
import mitt from 'mitt'

type AppEvents = {
  LOGOUT: { reason: string }
}

export const emitter = mitt<AppEvents>()
